import CommonModule from './common'
import EditorModule from './editor'
import ManagerModule from './manager'

export default {
  modules: {
    common: CommonModule,
    editor: EditorModule,
    manager: ManagerModule
  }
}
